import { useTheme } from '@emotion/react'

import Image from '@segment/matcha/components/Image'

import unitePaidAndOwnedChannelsMobilePng2x from './assets/UnitePaidAndOwnedChannelsMobile@2x.png'
import unitePaidAndOwnedChannelsMobileWebp from './assets/UnitePaidAndOwnedChannelsMobile.webp'
import unitePaidAndOwnedChannelsMobileWebp2x from './assets/UnitePaidAndOwnedChannelsMobile@2x.webp'

import unitePaidAndOwnedChannelsPng from './assets/UnitePaidAndOwnedChannels.png'
import unitePaidAndOwnedChannelsPng2x from './assets/UnitePaidAndOwnedChannels@2x.png'
import unitePaidAndOwnedChannelsWebp from './assets/UnitePaidAndOwnedChannels.webp'
import unitePaidAndOwnedChannelsWebp2x from './assets/UnitePaidAndOwnedChannels@2x.webp'

const UnitePaidAndOwnedChannelsImage = () => {
  const theme = useTheme()
  return (
    <>
      <picture>
        <source
          type="image/webp"
          media={theme.breakpoints.up(`sm`, false)}
          srcSet={`${unitePaidAndOwnedChannelsWebp}, ${unitePaidAndOwnedChannelsWebp2x} 2x`}
          width="1068"
          height="468"
        />
        <source
          media={theme.breakpoints.up(`sm`, false)}
          srcSet={`${unitePaidAndOwnedChannelsPng}, ${unitePaidAndOwnedChannelsPng2x} 2x`}
          width="1068"
          height="468"
        />
        <source
          type="image/webp"
          srcSet={`${unitePaidAndOwnedChannelsMobileWebp}, ${unitePaidAndOwnedChannelsMobileWebp2x} 2x`}
          width="342"
          height="550"
        />
        <Image
          width="320"
          height="600"
          src={unitePaidAndOwnedChannelsMobilePng2x}
          alt="Illustration: Unite paid and owned channels"
          loading="lazy"
        />
      </picture>
    </>
  )
}

export default UnitePaidAndOwnedChannelsImage
